module.exports = __webpack_public_path__ + "img/pho_com_nor@2x.3e871121.png";